/* eslint-disable import/default */

import React from 'react';
import { render } from 'react-dom';
import { AppContainer } from 'react-hot-loader';
import configureStore, { history } from './store/configureStore';
import Root from './components/Root';
import 'bulma/css/bulma.css';
import 'font-awesome/css/font-awesome.css'
import './styles/styles.scss';
import ReactPixel from 'react-facebook-pixel';
import ReactGA from 'react-ga4';
require('./favicon.ico'); // Tell webpack to load favicon.ico
ReactPixel.init('1521191942933312');
ReactGA.initialize('G-X9YFPSXX5B');
const store = configureStore();

render(
  <AppContainer>
    <Root store={store} history={history} />
  </AppContainer>,
  document.getElementById('app')
);

if (module.hot) {
  module.hot.accept('./components/Root', () => {
    const NewRoot = require('./components/Root').default;
    render(
      <AppContainer>
        <NewRoot store={store} history={history} />
      </AppContainer>,
      document.getElementById('app')
    );
  });
}
